import * as React from 'react';
//import * as _ from 'underscore';
import * as _ from 'underscore'; //LL: 16.07.23: try after OE's great changes in GIT
import * as $ from 'jquery';

import { IGlob } from '../../../../_common/application/ts/Glob';
import { ParameterField } from '../../../../_common/platform/tsx/ParameterField';
import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import StringField from '../../../../_common/platform/tsx/StringField';
import SelectField from '../../../../_common/platform/tsx/SelectField';
import { ExchangeObjectNameParameterField } from '../../../../_common/platform/tsx/BackendMethodParameterOptionsSelect';
import GroupingParameterField from '../../../../_common/platform/tsx/GroupingParameterField';

import ClickToFilterAttributeSelect, {
    IToggleStates
} from '../../../../_common/platform/tsx/filtering/ClickToFilterAttributeSelect';

import * as Utilities from '../../../../_common/platform/ts/Utilities';
import { IAttrQuery } from '../../../../pdc-widget-calendar/src/ts/components/Interfaces';
import { IPopupOptions } from '../../../../pdc-platform/src/ts/actions/DialogActions';

import { IAttribute } from '../../../../_common/platform/tsx/filtering/Interfaces';

import { ATTRIBUTE_TYPES } from '../../../../_common/platform/ts/ConfigurationConstants';

import { ITreeItem } from '../../../../pdc-platform/src/ts/stores/EntityModelsStore';
import GraphOptions, { IGraphOptionsValue } from '../../../../_common/platform/tsx/config/GraphOptions';
import SummaryOptions from '../../../../_common/platform/tsx/config/SummaryOptions';

const reactGlobalClick = require('_common/platform/ts/reactGlobalClick');

require('../../../../_common/platform/sass/attribute-options-select.sass');

export interface IAttributeOptionsSelectProperties {
    value: IAttrQuery;
    dataSourceID: number;
    attributeType: string;
    showGraph: boolean;
    entitiesTree: ITreeItem[];
    entityCollapsedDict: IToggleStates;
    disableClickToFilter: boolean;
    showFixedPosition: boolean;
    endlessScrollingIsOn: boolean;
    tabID: number;
    glob: IGlob;

    onChange?(value: IAttrQuery): void;
    onEntityCollapsedDictChange?(value): void;
}

interface IOptionsSelectPopupOptions extends IPopupOptions {
    value: IAttrQuery;
    dataSourceID: number;
    attributeType: string;
    showGraph: boolean;
    entitiesTree: ITreeItem[];
    entityCollapsedDict: IToggleStates;
    disableClickToFilter: boolean;
    showFixedPosition: boolean;
    endlessScrollingIsOn: boolean;
    tabID: number;

    onChange(value: IAttrQuery): void;
    onEntityCollapsedDictChange(value): void;
}

function OptionsSelectPopup(props: {
    zIndex: number;
    options: IOptionsSelectPopupOptions;
    glob: IGlob;

    close(): void;
}) {
    const [value, setValue] = React.useState<IAttrQuery>(props.options.value != null ? { ...props.options.value } : {});
    const [errors, setErrors] = React.useState<string[]>([]);
    const [size, setSize] = React.useState({
        height: 480,
        width: 600
    });
    const globalClickIndex = React.useRef(0); //LL: 04.09.19: problem when click "Save" on Config dialog instead of this dialog
    const popoverBody = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const dialog = popoverBody.current;

        globalClickIndex.current = reactGlobalClick.register(props.close);

        setSize({
            height: dialog.clientHeight,
            width: dialog.clientWidth
        });

        return () => {
            reactGlobalClick.unregister(globalClickIndex.current);
            globalClickIndex.current = undefined;
        };
    }, []);

    const getValueCopy = () => {
        return { ...value };
    };

    const handleOKButtonClick = () => {
        if (validate(value)) {
            props.close();

            if (typeof props.options.onChange === 'function') {
                const valueCopy = getValueCopy();

                props.options.onChange(valueCopy);
            }
        }
    };

    const validate = (value: IAttrQuery) => {
        return (
            validateSummaryTemplate('Total', value.summaryFormat) &&
            validateSummaryTemplate('Group', value.groupSummaryFormat)
        );
    };

    const validateSummaryTemplate = (tag: string, val: string) => {
        const msg = tag + ' Summary template should contain value placeholder {0}';

        if (val != null && val.indexOf('{0}') == -1) {
            if (!_.contains(errors, msg)) {
                const newErrors = _.clone(errors);

                newErrors.push(msg);

                setErrors(newErrors);
            }
            return false;
        } else {
            setErrors(_.without(errors, msg));
            return true;
        }
    };

    const handleClickToFilterAttributeChange = (attribute: IAttribute) => {
        const valueCopy = getValueCopy();

        if (attribute != null) {
            valueCopy.clickToFilterAttribute = attribute;
        } else {
            delete valueCopy.clickToFilterAttribute;
        }

        setValue(valueCopy);
    };

    const handleOnHideColumnChange = (value: boolean) => {
        const valueCopy = getValueCopy();

        //valueCopy.hideColumn = value;
        //LL: 02.03.21: So,
        //  old value "hideColumn" = my new "columnForInternalUse"
        //  add new value = "hideColumnActual" for 'Initially Hidden Column'
        valueCopy.hideColumnActual = value;

        setValue(valueCopy);
    };

    const handleOnPutValueInExchangeObjectChange = (value: boolean) => {
        const valueCopy = getValueCopy();

        if (value) {
            valueCopy.putValueInExchangeObject = true;
        } else {
            delete valueCopy.putValueInExchangeObject;
        }

        setValue(valueCopy);
    };

    const handleOnExchangeObjectNameChange = (value: string) => {
        const valueCopy = getValueCopy();

        if (value.length > 0) {
            valueCopy.exchangeObjectName = value;
        } else {
            delete valueCopy.exchangeObjectName;
        }

        setValue(valueCopy);
    };

    const handleOnUseForRowChange = (value: boolean) => {
        const valueCopy = getValueCopy();

        if (value) {
            valueCopy.useForRowHighlighting = true;
        } else {
            delete valueCopy.useForRowHighlighting;
        }

        setValue(valueCopy);
    };

    //LL: 18.02.21:  //LL: it is renamed old checkbox
    const handleColumnForInternalUseChange = (value: boolean) => {
        const valueCopy = getValueCopy();

        //valueCopy.columnForInternalUse = value;
        //LL: 02.03.21: So,
        //  old value "hideColumn" = my new "columnForInternalUse"
        //  add new value = "hideColumnActual" for 'Initially Hidden Column'
        valueCopy.hideColumn = value;
        valueCopy.columnForInternalUse = value;

        setValue(valueCopy);
    };

    const handleFixedPositionChange = (value: boolean) => {
        const valueCopy = getValueCopy();

        if (value) {
            valueCopy.fixed = value;
        } else {
            delete valueCopy.fixed;
        }

        setValue(valueCopy);
    };

    const handleGraphOptionsChange = (value: IGraphOptionsValue) => {
        const valueCopy = getValueCopy();

        valueCopy.showGraph = value.showGraph;
        valueCopy.graphOption = value.graphOption;

        setValue(valueCopy);
    };

    const handleOnSummaryOptionsChange = (value: IAttrQuery) => {
        setValue(value);
    };

    const options = props.options;
    const popoverStyle = Utilities.getPopoverStyle(options, size);
    const style: React.CSSProperties = {
        display: 'block',
        left: popoverStyle.left,
        top: popoverStyle.top,
        zIndex: props.zIndex
    };

    let fixedPosition: React.JSX.Element;

    if (options.showFixedPosition) {
        const fixed = value.fixed != null ? value.fixed : false;

        fixedPosition = (
            <ParameterField noTitle={true} clearable={false}>
                <BooleanField
                    title={'Fix column to a side'}
                    value={fixed}
                    allowNull={false}
                    onChange={handleFixedPositionChange}
                />
            </ParameterField>
        );
    }

    let graphOptions: React.JSX.Element;

    if (value.attribute != null && options.showGraph) {
        graphOptions = <GraphOptions value={value} onChange={handleGraphOptionsChange} />;
    }

    let summaryWarning: React.JSX.Element;

    if (options.endlessScrollingIsOn && value.showSum) {
        summaryWarning = (
            <div className="summary-warning">
                <span>{'Summary is not supported when Endless Scrolling is on'}</span>
            </div>
        );
    }

    let errorsElement: React.JSX.Element;

    if (errors.length > 0) {
        errorsElement = <div className="text-danger">{errors.join(', ')}</div>;
    }

    //LL: 02.03.21:
    //  by Leo:
    //       Old tests should not fail.
    //       The Hidden columns is a new feature.
    //       Label for Old options was renamed to avoid misunderstandings…)))
    //  1[]  (= old)   "Hidden" -> "Col for Internal Use"    value = "hideColumn"  my "columnForInternalUse"  must be equal to it
    //  2[]  (= new)  "Initially Hidden"  my using of "hideColumn" is wrong.   value = "hideColumnActual"
    //LL: 02.03.21: So,
    //  old value "hideColumn" = my new "columnForInternalUse"
    //  add new value = "hideColumnActual" for 'Initially Hidden Column'
    //     they are used in WidgetStore

    let useForRowSelection: React.JSX.Element;

    if (options.attributeType === ATTRIBUTE_TYPES.BOOLEAN) {
        useForRowSelection = (
            <ParameterField noTitle={true} clearable={false}>
                <BooleanField
                    title={'Use For Row Highlighting'}
                    value={value.useForRowHighlighting || false}
                    allowNull={false}
                    onChange={handleOnUseForRowChange}
                />
            </ParameterField>
        );
    }

    let exchangeObjectNameElement: React.JSX.Element;

    if (value.putValueInExchangeObject) {
        exchangeObjectNameElement = (
            <ExchangeObjectNameParameterField
                value={value.exchangeObjectName}
                onChange={handleOnExchangeObjectNameChange}
            />
        );
    }

    const columnForInternalUse = value.hideColumn != null ? value.hideColumn : false;
    const hideColumnActual = value.hideColumnActual != null ? value.hideColumnActual : columnForInternalUse;

    return (
        <div className="attribute-options-select-dialog">
            <div
                className={'popover attribute-options-select-popover-calendar ' + popoverStyle.side}
                style={style}
                ref={popoverBody}
            >
                <div className="arrow" style={{ top: popoverStyle.arrowTop }}></div>
                <h3 className="popover-header">
                    {'More Options'}

                    <button type="button" className="close" onClick={props.close}>
                        ×
                    </button>
                </h3>
                <div>
                    <div className="popover-body">
                        {errorsElement}

                        <ClickToFilterAttributeSelect
                            value={value.clickToFilterAttribute}
                            attributeName={value}
                            dataSourceID={options.dataSourceID}
                            entitiesTree={options.entitiesTree}
                            entityCollapsedDict={options.entityCollapsedDict}
                            disableByOption={options.disableClickToFilter}
                            tabID={options.tabID}
                            glob={props.glob}
                            onChange={handleClickToFilterAttributeChange}
                            onEntityCollapsedDictChange={options.onEntityCollapsedDictChange}
                        />

                        <ParameterField noTitle={true} clearable={false}>
                            <BooleanField
                                title={'Column for internal use in the Widget'}
                                value={columnForInternalUse}
                                allowNull={false}
                                onChange={handleColumnForInternalUseChange}
                            />
                        </ParameterField>

                        <ParameterField noTitle={true} clearable={false}>
                            <BooleanField
                                title={'Initially Hidden Column'}
                                value={hideColumnActual}
                                allowNull={false}
                                onChange={handleOnHideColumnChange}
                            />
                        </ParameterField>

                        <ParameterField noTitle={true} clearable={false}>
                            <BooleanField
                                title={'Put Selected Value in Exchange Object'}
                                value={value.putValueInExchangeObject || false}
                                allowNull={false}
                                onChange={handleOnPutValueInExchangeObjectChange}
                            />
                        </ParameterField>

                        {exchangeObjectNameElement}

                        {useForRowSelection}

                        {fixedPosition}

                        <SummaryOptions
                            value={value}
                            attributeType={options.attributeType}
                            onChange={handleOnSummaryOptionsChange}
                        />

                        {summaryWarning}

                        {graphOptions}
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="btn btn-success button-confirm" onClick={handleOKButtonClick}>
                        {'OK'}
                    </div>

                    <button className="btn btn-default" onClick={props.close}>
                        {'Cancel'}
                    </button>
                </div>
            </div>

            <div className="modal-backdrop fade show"></div>
        </div>
    );
}

export default function AttributeOptionsSelect(props: IAttributeOptionsSelectProperties) {
    const handleOnChange = (value: IAttrQuery) => {
        if (typeof props.onChange === 'function') {
            props.onChange(value);
        }
    };

    const handleSelectorShow = (e) => {
        const offset = $(e.target).offset();

        props.glob.DialogActions.createPopup<IOptionsSelectPopupOptions>('custom', {
            value: props.value,
            dataSourceID: props.dataSourceID,
            attributeType: props.attributeType,
            top: offset.top,
            left: offset.left,

            showGraph: props.showGraph,
            entitiesTree: props.entitiesTree,
            entityCollapsedDict: props.entityCollapsedDict,
            disableClickToFilter: props.disableClickToFilter,
            showFixedPosition: props.showFixedPosition,
            endlessScrollingIsOn: props.endlessScrollingIsOn,
            tabID: props.tabID,

            onChange: handleOnChange,
            onEntityCollapsedDictChange: props.onEntityCollapsedDictChange,

            component: OptionsSelectPopup
        });
    };

    return (
        <div className="attribute-options-select">
            <div className="content">
                <span className="glyphicon glyphicon-cog" onClick={handleSelectorShow}></span>

                <span className="value" title={''}>
                    <em className="empty" onClick={handleSelectorShow}></em>
                </span>
            </div>
        </div>
    );
}

